<div
  [class]="{
		'constrained-width-pc': cService.isPcViewport,
		'constrained-width-large-pc': cService.isLargePcViewport
	}"
  [dir]="cService.selectedLanguage?.isRtl ? 'rtl' : 'ltr'"
>
  <vrm-dialog-header
    [dialogTitle]='promptConfig.title'
    [hideClose]='promptConfig.hideHeaderCloseButton'
    [titleDescription]='promptConfig.titleDescription'
  ></vrm-dialog-header>

  <div style='height: 5px'>
    <mat-progress-bar
      color='primary'
      mode='buffer'
      [class.hidden]='!cService.hideIndeterminateProgress || !cService.promptConfig.showQueryProgress'
    ></mat-progress-bar>
  </div>

  <mat-dialog-content style='min-height: 20vh; border-bottom: 2px solid #ccc'>
    <div class='padding-15' [innerHTML]='promptConfig.body | trustAsSafeHtml'></div>

    <div class='padding-15' *ngIf='cService.promptConfig.determinateProgressPerc !== undefined'>
      <mat-progress-bar
        mode='determinate'
        [value]='cService.promptConfig.determinateProgressPerc'
      ></mat-progress-bar>
      <div>
        <small> {{ cService.promptConfig.determinateProgressPerc | numberToDecimalPlaces: 0 }}% </small>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align='end'>
    <div class='padding-l-10 padding-r-10'>
      <button
        class='sharp-corners bold'
        mat-button
        mat-dialog-close
        *ngIf='promptConfig.cancelButtonText'
        [disabled]='
					cService.promptConfig.disableCancelWhenQuerying &&
					cService.promptConfig.showQueryProgress &&
					cService.hideIndeterminateProgress
				'
      >
        {{ promptConfig.cancelButtonText }}
      </button>
      <button
        class='sharp-corners bold'
        *ngIf='promptConfig.actionButtonText'
        mat-raised-button
        vrm-raised-button
        vrm-bg-color
        [mat-dialog-close]='true'
      >
        {{ promptConfig.actionButtonText }}
      </button>
    </div>
  </mat-dialog-actions>
</div>
